import * as Yup from 'yup';

import { Strings } from '@app/constants';

export const addCandidateSchema = Yup.object()
  .shape({
    firstName: Yup.string()
      .trim()
      .required(Strings.validation.fieldRequired(Strings.field.firstName)),
    lastName: Yup.string()
      .trim()
      .required(Strings.validation.fieldRequired(Strings.field.lastName)),
    personalEmail: Yup.string()
      .trim()
      .required(Strings.validation.fieldRequired(Strings.field.personalEmail))
      .email(Strings.validation.invalidEmail),
    source: Yup.string().required(Strings.validation.selectRequired(Strings.field.source)),
    resume: Yup.string().required(Strings.validation.uploadRequired(Strings.field.resume)),
    applyingFor: Yup.string().required(Strings.validation.fieldRequired(Strings.field.applyingFor)),
    other: Yup.string()
      .trim()
      .nullable()
      .test(
        'is-Other',
        Strings.validation.fieldRequired(Strings.field.sourceName),
        function (value) {
          const source = this.parent.source;
          if (source === 'Other') {
            return !!value;
          }
          return true;
        }
      ),
    referenceBy: Yup.string()
      .trim()
      .nullable()
      .test(
        'is-Reference',
        Strings.validation.fieldRequired(Strings.field.referenceName),
        function (value) {
          const source = this.parent.source;
          if (source === 'Reference') {
            return !!value;
          }
          return true;
        }
      ),
  })
  .required();
export const updateCandidateStatusSchema = Yup.object()
  .shape({
    reason: Yup.string()
      .trim()
      .required(Strings.validation.fieldRequired(Strings.field.reason))
      .test('is-not-empty', 'Reason cannot be empty', (value) => value.trim().length > 0),
  })
  .required();
